module.exports = __webpack_public_path__ + "static/img/13.d8e9d81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/zh/13.png
// module id = YqKs
// module chunks = 0